import * as logger from "@/services/LoggerService.js";
import AppSettings from "@/appsettings/appsettings.js";

function receiveMessage(event, callback, origin, parentFunction) {
  if (event.origin !== origin) return;
  callback(event.data);
  window.removeEventListener("message", parentFunction);
}

export function messagePostSetup(origin, updateFields) {
  if (!(window.opener && window.opener !== window)) return;

  window.opener.postMessage("ready", origin);

  window.addEventListener(
    "message",
    function(e) {
      receiveMessage(e, updateFields, origin, this);
    },
    false
  );
}

export function getDomain() {
  return location.origin;
}

export function getDefaultReceiptUrl() {
  const origin = getDomain();
  return `${origin}/receipt`;
}

export function generatePaymentPageQueryObject(orderNumber, amount, returnUrl) {
  const data = {
    orderNumber: orderNumber,
    amount: amount,
    return: returnUrl
  };

  const neiyxfh = btoa(JSON.stringify(data));
  const jcpxaqh = btoa(Math.random());
  const ewygajd = btoa(Math.random());
  const lsdoptc = btoa(Math.random());
  const uslkhcd = btoa(Math.random());
  return {
    neiyxfh: lsdoptc,
    jcpxaqh: ewygajd,
    lsdoptc: neiyxfh,
    uslkhcd: jcpxaqh,
    ewygajd: uslkhcd
  };
}

function checkOrigin(origin, url) {
  let arr = url.match(/:\/\/(.[^/]+)/);
  return !!arr && arr.length > 1 && arr[1] == origin;
}

export function checkOriginArray(originArray, url) {
  for (var i = 0; i < originArray.length; i++) {
    if (checkOrigin(originArray[i], url)) return true;
  }

  return false;
}

export function extractZoneFromOrderNumber(tenantAlias, orderNumber) {
  try {
    const masterCardDiscountMerchants = AppSettings.masterCardDiscountMerchants;
    if (!masterCardDiscountMerchants.includes(tenantAlias)) return null;
    if (!orderNumber) return null;
    orderNumber = orderNumber.toString().replace(/\s/g, "");
    if (!orderNumber.includes("-")) return null;
    let locationInfo = orderNumber.split("-");
    if (locationInfo.length < 1) return null;
    locationInfo = locationInfo[0];
    if (locationInfo.length < 3) return null;
    const zone = locationInfo.substring(1);
    return zone;
  } catch (e) {
    logger.error(e);
  }
  return null;
}

function getZoneDiscountAmount(zone) {
  if (!zone) return 0;
  const zoneCost = {
    Z1: 800,
    Z2: 1100,
    Z3: 800,
    Z4: 800,
    Z5: 800,
    Z6: 800,
    Z7: 800,
    STCATH: 1500,
    ANW: 1100,
    DEFAULT: 2900
  };

  let cost = zoneCost[zone];

  if (cost == null || cost == undefined) return zoneCost.DEFAULT;

  return cost;
}

export function determineMasterCardDiscount(
  cardType,
  zone,
  addDiscount,
  removeDiscount
) {
  if (!zone) return;
  const masterCard = "Master Card";
  const discountName = "Master Card Discount";
  if (cardType === masterCard) {
    const amount = getZoneDiscountAmount(zone);
    addDiscount(discountName, amount);
  } else {
    removeDiscount(discountName);
  }
}

function decodeData(encodedData) {
  let decodedResult = encodedData;
  try {
    decodedResult = atob(encodedData);
  } catch (e) {
    logger.error("There was an error base64 decoding the query parameter");
    logger.error(e);
  }
  return JSON.parse(decodedResult);
}

export function extractDataFromQueryString(queryParams, updateFields) {
  if (queryParams.lsdoptc != undefined) {
    let data = decodeData(queryParams.lsdoptc);
    updateFields(data);
    return true;
  }
  return false;
}
